__turbopack_context__.v({
  "button": "SubscribeForm-module-scss-module__F2ilIa__button",
  "container": "SubscribeForm-module-scss-module__F2ilIa__container",
  "description": "SubscribeForm-module-scss-module__F2ilIa__description",
  "error": "SubscribeForm-module-scss-module__F2ilIa__error",
  "form": "SubscribeForm-module-scss-module__F2ilIa__form",
  "formWrapper": "SubscribeForm-module-scss-module__F2ilIa__formWrapper",
  "hero": "SubscribeForm-module-scss-module__F2ilIa__hero",
  "illustration": "SubscribeForm-module-scss-module__F2ilIa__illustration",
  "input": "SubscribeForm-module-scss-module__F2ilIa__input",
  "success": "SubscribeForm-module-scss-module__F2ilIa__success",
  "title": "SubscribeForm-module-scss-module__F2ilIa__title",
  "withError": "SubscribeForm-module-scss-module__F2ilIa__withError",
  "wrapper": "SubscribeForm-module-scss-module__F2ilIa__wrapper",
});
